import { Grid, MenuItem } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersLayout, FiltersButtons, SearchField, SMBSelect } from '../../../components';
import { IJobTitle } from '../../../models';

interface IUsersListFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
  setSelectedJobTitle?: (val: string | number) => void;
  selectedJobTitle?: string | number;
  isLoadingJobTitles: boolean;
  jobTitles: IJobTitle[];
}

export const UsersListFilters: FC<IUsersListFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  searchPlaceholder,
  setSelectedJobTitle,
  selectedJobTitle,
  isLoadingJobTitles,
  jobTitles
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      {setSelectedJobTitle && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SMBSelect
            variant="outlined"
            handleClear={() => {
              setSelectedJobTitle('');
            }}
            name={`emailType`}
            id={`emailType`}
            label="Job Title"
            value={selectedJobTitle}
            disabled={isLoadingJobTitles || isLoading}
            onChange={event => {
              setSelectedJobTitle(event.target.value);
            }}
          >
            {jobTitles?.map((jobTitle, index) => {
              return (
                <MenuItem key={`${index}`} value={jobTitle.value}>
                  {jobTitle.description}
                </MenuItem>
              );
            })}
          </SMBSelect>
        </Grid>
      )}
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchedValue && setSearchedValue('');
            setSearchValue && setSearchValue('');
            setSelectedJobTitle && setSelectedJobTitle('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
